export default __webpack_public_path__ + "static/media/floatLogo.98d36322.svg";